/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type H1IssueRow_issue$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type H1IssueTable_project$ref: FragmentReference;
export type H1IssueTable_project = {|
  +host: string,
  +crawls: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +countTypesH1Issues: ?$ReadOnlyArray<?{|
          +type: string,
          +severity: number,
          +count: number,
        |}>,
        +h1Issues: ?{|
          +count: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +$fragmentRefs: H1IssueRow_issue$ref
            |}
          |}>,
        |},
      |}
    |}>
  |},
  +$refType: H1IssueTable_project$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v1 = {
  "kind": "Variable",
  "name": "h1",
  "variableName": "h1",
  "type": "TextFilters"
},
v2 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "H1IssueTable_project",
  "type": "Project",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "limit",
      "type": "Int",
      "defaultValue": 20
    },
    {
      "kind": "LocalArgument",
      "name": "typeFilters",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "h1",
      "type": "TextFilters",
      "defaultValue": v0
    },
    {
      "kind": "LocalArgument",
      "name": "url",
      "type": "TextFilters",
      "defaultValue": v0
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "host",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "crawls",
      "storageKey": "crawls(limit:1,offset:0)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "offset",
          "value": 0,
          "type": "Int"
        }
      ],
      "concreteType": "CrawlsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CrawlsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Crawl",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "countTypesH1Issues",
                  "storageKey": null,
                  "args": [
                    v1,
                    v2
                  ],
                  "concreteType": "CountType",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "severity",
                      "args": null,
                      "storageKey": null
                    },
                    v3
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "h1Issues",
                  "storageKey": null,
                  "args": [
                    v1,
                    {
                      "kind": "Variable",
                      "name": "limit",
                      "variableName": "limit",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "offset",
                      "variableName": "offset",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "typeFilters",
                      "variableName": "typeFilters",
                      "type": "[String]"
                    },
                    v2
                  ],
                  "concreteType": "H1IssuesConnection",
                  "plural": false,
                  "selections": [
                    v3,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "H1IssuesEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "H1Issue",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "H1IssueRow_issue",
                              "args": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '8b8b9b67125de20395bfcb50a047d4b3';
module.exports = node;
